<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <div class="box">
          <div class="box-header">
            <h5 class="box-title">CC Import Details</h5>
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="conBooking" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <!-- <th>Sr no</th> -->
                  <th>Assignment</th>

                  <th>More Details</th>

                  <th
                    v-if="
                      designation == 'superviser' &&
                      departmentName == 'Port/ICD'
                    "
                  >
                    Status
                  </th>
                  <!-- <th>FF Activity Type</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in AirImportData" :key="index">
                  <!-- <td>{{index+1}}</td> -->

                  <td
                    @click="
                      viewExportAirPage(item1.ccImportId, item1.statusFinal)
                    "
                    class="showMoreData"
                  >
                    <b>Assignment No. :</b>
                    {{ item1.ccImportSeries }}
                    <br />
                    <b>Importer :</b>
                    {{ item1.Importer }}
                    <br />
                    <b>Exporter :</b>
                    {{ item1.Exporter }}
                  </td>
                  <td>
                    <b>Place of Receipt :</b>
                    {{ item1.placeRecp }}
                    <br />
                    <b>Load Port Name :</b>
                    {{ item1.LoadPort }}
                    <br />
                    <b>Port Of Discharge :</b>
                    {{ item1.placeDis }}
                    <br />
                    <b>Final Delivery :</b>
                    {{ item1.finalPlace }}
                  </td>
                  <td
                    v-if="
                      designation == 'superviser' &&
                      departmentName == 'Port/ICD'
                    "
                    :style="
                      item1.ffRailOutId == null || item1.ffRailOutId == ''
                        ? { color: 'red' }
                        : { color: 'green' }
                    "
                  >
                    {{
                      item1.ffRailOutId == "" || item1.ffRailOutId == null
                        ? "Pending"
                        : "Completed"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Client")) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCImportDetails");

      this.viewFFExportFCL();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      isLoading: false,
      designation: "",
      departmentName: "",

      AirImportData: [],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading
    CustomLoader,
  },

  computed: {},

  methods: {
    goToMain() {
      this.$sessionsStorage.set("editCcImportId", "");
      this.$router.push({
        path: "/ccImport/CCImportEntry",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportAirPage(AIR, status) {
      this.$sessionsStorage.set("editCcImportId", AIR);
      let data = {
        jobType: "2",
        typeOf: "1",
        status: "",
        msgType: "1",
        allMessageId: AIR,
        statusMain: status,
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/clientChatScreen",
      });
    },
    viewFFExportFCL() {
      this.isLoading = true;
      let payload = {
        view: "view",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_ClientDashboard/viewCCImportList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.SeaConImportDetails.length > 0) {
              this.AirImportData = data.SeaConImportDetails;
            }

            if (data.UserDetail.length > 0) {
              this.designation = data.UserDetail[0].designation;

              let filter1 = data.UserDetail[0].departmentName1
                .split(",")
                .filter((x) => {
                  return x == "Port/ICD";
                });

              this.departmentName = filter1.length > 0 ? "Port/ICD" : "fdsf";
            }

            this.JqueryFun();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// clientCcImport.vue?f0d3567e